class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    if (!this.detailsContainer) return;

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
    });
    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.summaryToggle.setAttribute('role', 'button');
    }
    this.querySelectorAll('button[type="button"][data-modal-close], .search-modal__overlay').forEach((el) =>
      el.addEventListener('click', this.close.bind(this))
    );
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.detailsContainer.hasAttribute('open')) this.close();
    else this.open();
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');
    const input = this.querySelector('input[type="search"]');
    if (input) setTimeout(() => input.focus(), 50);
  }

  close() {
    this.detailsContainer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  }
}
customElements.define('details-modal', DetailsModal);
